export const VERSIONS_XML_PMAX = "PM";
export const VERSIONS_XML_NEO = "NEO";
